<template>

	<router-view></router-view>

	<template v-if="errors">
		<p class="alert alert-error">{{ errors }}</p>
	</template>

    <!-- vuejs-confirm-dialog wrapper element -->
	<DialogsWrapper />

</template>


<script lang="ts">

import {useUsersStore} from "@/stores/Users.store";
import {mapActions, mapStores} from "pinia";
import {usePreferencesStore} from "@/stores/Preferences.store";
import LoadingScreen from "./components/ui/LoadingScreen.vue";
import {DialogsWrapper} from "vuejs-confirm-dialog";

export default {
	components: {
		DialogsWrapper,
		LoadingScreen
	},
	data() {
		return {
			initialized: false,
			loading: true,
			errors: null,
		};
	},

	computed: {
		...mapStores(usePreferencesStore),
	},

	methods: {
		...mapActions(useUsersStore, [ 'loadMe' ]),
	},
}
</script>
